"use strict";
$(document).ready(() => {
    const externalPopupRef = $("#external-popup");
    const externalPopupCardRef = $("#external-popup-card");
    const externalPopupCancelRef = $("#external-popup-cancel");
    const externalPopupSuccessRef = $("#external-popup-success");
    let url = "";
    let target = "";
    externalPopupCancelRef.on("click", () => {
        externalPopupRef.fadeOut("fast");
    });
    externalPopupSuccessRef.on("click", () => {
        if (target == "_blank") {
            window.open(url);
        }
        else {
            window.location.href = url;
        }
        externalPopupRef.fadeOut();
    });
    document.addEventListener("click", (e) => {
        const node = e.target;
        const anchor = node.closest('a[data-external="true"]');
        if (!anchor) {
            return;
        }
        e.preventDefault();
        url = anchor.href;
        target = anchor.target;
        externalPopupRef.fadeIn("fast");
    });
});
